import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import {connect} from 'react-redux';
import {
  setSelectedCellcomTvProd,
  reportAnalytics,
  goToPage,
} from '../PremiumPackagesHolder/PremiumPackagesHolderSlice';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import blockBackground from '../images/block_background.svg';
const cellcomTvSubscriptions = (props) => {
  let setSelectedProductHandler = (product) => {
    props.reportAnalytics({
      eventCategory: 'premium_packages',
      eventAction: 'click_1',
      eventLabel: 'element_2',
    });
    props.goToPage('packages');
    props.setSelectedCellcomTvProd(product);
  };

  let createSubscriptionBlock = () => {
    props.reportAnalytics({
      eventCategory: 'premium_packages',
      eventAction: 'visibility_1',
      eventLabel: 'element_1',
    });
    return (
      <div>
        {props.tvUsersList.map(function (item, index) {
          return (
            <section className='block' style={{ backgroundImage: blockBackground.bg() }} onClick={() => setSelectedProductHandler(item)} key={index}>
              <Image className='block-image' src={require('../images/icon_tv.svg')} alt='תמונה tv' />
              <p className='block-text-bold'>מנוי {window.Config.brand_Name_HE} טיוי</p>
              <p className='block-text'>{item.userName}</p>
              <p className='block-text'>
                {item.banPsidBillingAddress
                  ? item.banPsidBillingAddress.streetName +
                    ' ' +
                    item.banPsidBillingAddress.houseNum +
                    ' ' +
                    item.banPsidBillingAddress.city
                  : null}
              </p>
              <Image className='block-select' src={require('../images/select_sub.svg')} alt='תמונה tv' />
            </section>
          );
        })}
      </div>
    );
  };

  return (
    <section className='cellcom-tv-subscriptions'>
      {props.tvUsersList ? (
        <div className='subscriptions'>
          <div className='title'>
            <p>היי,</p>
            <p>על איזה שירות {window.Config.brand_Name_HE} TV אנחנו מדברים? </p>
          </div>
          <p className='text'> על איזה מנוי תרצו לבצע את הפעולה?</p>
          {createSubscriptionBlock()}
        </div>
      ) : null}
    </section>
  );
};

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = { setSelectedCellcomTvProd, reportAnalytics, goToPage};

export default connect(mapStateToProps, mapDispatchToProps)(cellcomTvSubscriptions);
